{
  "name": "circuit-json-to-gerber",
  "version": "0.0.84",
  "license": "MIT",
  "main": "dist/index.js",
  "type": "module",
  "scripts": {
    "build": "tsup-node src/index.ts src/cli.ts --format esm --dts --sourcemap",
    "format": "biome format --write .",
    "format:check": "biome format .",
    "start": "bun --bun site/index.html",
    "build:site": "bun build site/index.html --outdir ./site-export"
  },
  "files": [
    "dist"
  ],
  "bin": {
    "circuit-to-gerber": "./dist/cli.js"
  },
  "devDependencies": {
    "@biomejs/biome": "^1.8.3",
    "@types/archiver": "^6.0.3",
    "@types/bun": "^1.1.8",
    "@types/node": "^22.5.2",
    "@types/react": "^19.2.7",
    "@types/react-dom": "^19.1.5",
    "archiver": "^7.0.1",
    "bun-match-svg": "^0.0.13",
    "circuit-json": "^0.0.450",
    "commander": "^12.1.0",
    "format-si-unit": "^0.0.7",
    "gerber-to-svg": "^4.2.8",
    "gerberts": "^0.0.3",
    "jszip": "^3.10.1",
    "pcb-stackup": "^4.2.8",
    "react": "^19.2.1",
    "react-dom": "^19.2.1",
    "tscircuit": "^0.0.1776",
    "tsup": "^8.2.4"
  },
  "peerDependencies": {
    "typescript": "^5.0.0",
    "tscircuit": "*",
    "circuit-json": "*"
  },
  "dependencies": {
    "@tscircuit/alphabet": "^0.0.25",
    "fast-json-stable-stringify": "^2.1.0",
    "polygon-clipping": "^0.15.7",
    "transformation-matrix": "^3.0.0"
  }
}
